export enum FontColorEnum {
  GREEN = 'green',
  RED = 'red',
}
